import { request } from "@/utils/request";
import { BASE_URL } from "@/constants/config";

export const FILES_ENDPOINTS = {
  upload: `${BASE_URL}api/files/upload/`,
  download: `${BASE_URL}api/files/download/`,
  delete: `${BASE_URL}api/files/delete/`,
  list: `${BASE_URL}api/files/list/`,
  availableFileTypes: `${BASE_URL}api/files/available_file_types/`,
};

class Files {
  async removeFile(query) {
    const { data } = await request({
      url: FILES_ENDPOINTS.delete,
      method: "DELETE",
      query,
    });
    return data;
  }

  async fetchAvailableFileTypes() {
    const { data } = await request({
      url: FILES_ENDPOINTS.availableFileTypes,
    });
    return data;
  }

  async fetchFiles() {
    const { data } = await request({
      url: FILES_ENDPOINTS.list,
    });
    return data;
  }
}

export const FilesService = new Files();
